import { render, staticRenderFns } from "./AudioControls.vue?vue&type=template&id=96da9bb0&scoped=true&"
import script from "./AudioControls.vue?vue&type=script&lang=js&"
export * from "./AudioControls.vue?vue&type=script&lang=js&"
import style0 from "./AudioControls.vue?vue&type=style&index=0&id=96da9bb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96da9bb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
